import { baseApi } from "./baseApi";

const DATA_INTEGRATION_BASE_URL = "/dataIntegrations";

export const dataIntegrationApi = baseApi.injectEndpoints({
  tagTypes: ["DataIntegration"],

  endpoints: (build) => ({
    addDataIntegration: build.mutation({
      query: (payload) => ({
        url: DATA_INTEGRATION_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "DataIntegration", id: "LIST" }],
    }),

    listDataIntegration: build.query({
      query: (params) => ({
        url: DATA_INTEGRATION_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "DataIntegration", _id })),
              { type: "DataIntegration", id: "LIST" },
            ]
          : [{ type: "DataIntegration", id: "LIST" }],
    }),

    getDDLDataIntegrationList: build.query({
      query: (params) => ({ url: `${DATA_INTEGRATION_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "DataIntegration", _id })),
              { type: "DataIntegration", id: "DDL" },
            ]
          : [{ type: "DataIntegration", id: "DDL" }],
    }),


    getDataIntegrationDetail: build.query({
      query: (licenceId) => `${DATA_INTEGRATION_BASE_URL}/${licenceId}`,
      providesTags: (result, error, { _id }) => [
        { type: "DataIntegration", _id },
        { type: "DataIntegration", id: "LIST" },
      ],
    }),

    updateDataIntegration: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${DATA_INTEGRATION_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "DataIntegration", id },
        { type: "DataIntegration", id: "LIST" },
      ],
    }),

  }),
  overrideExisting: false,
});

export const {
  useListDataIntegrationQuery,
  useLazyListDataIntegrationQuery,
  useAddDataIntegrationMutation,
  useGetDataIntegrationDetailQuery,
  useUpdateDataIntegrationMutation,
  useGetDDLDataIntegrationListQuery,
  useLazyGetDDLDataIntegrationListQuery,
} = dataIntegrationApi;
